import gql from 'graphql-tag';
import OrderRow from './fragmentOrderRow';

export default gql`
  mutation SendOrdersToDispatchTrack($input: SendOrdersToDispatchTrackInput!) {
    sendOrdersToDispatchTrack(input: $input) {
      orders {
        ...OrderRow
      }
    }
  }
  ${OrderRow}
`;



// WEBPACK FOOTER //
// ./src/queries/sendOrdersToDispatchTrack.js